// store/modules/reviews.js
import { getPageByCode } from "@/Services/api/PagesService";
import PagesCodes from "@/constants/PagesCode";

export default {
    state: () => ({
        reviews: [],
    }),

    mutations: {
        SET_REVIEWS(state, reviews) {
            state.reviews = reviews;
        },
    },

    actions: {
        async fetchReviews({ commit }) {
            try {
                const data = await getPageByCode(PagesCodes.ReviewsPage);
                commit("SET_REVIEWS", data.data.reviews || []);
            } catch (error) {
                console.error("Error fetching reviews:", error);
            }
        }
    },

    getters: {
        reviews: (state) => state.reviews,
    }
};
